import React from 'react'
import Layout from '../../../../component/layout/Layout'
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const IndustrialScale = () => {

     const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
    };

    // 🔥 Replace with actual images
    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FbioEngineering%2F3.png?alt=media&token=e15a6385-524d-4577-add1-a48a9f72d7fd',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FbioEngineering%2F3.png?alt=media&token=e15a6385-524d-4577-add1-a48a9f72d7fd'
    ];



  return (
    <Layout>
        {/* BREADCRUMB */}
        <div className="bread">
            <ul className="collapsed">
                <li><a href="/">Home</a></li>
                <li><a href="/">Bio-Engineering Instruments</a></li>
            </ul>
        </div>

        {/* TITLE */}
        <div className="container">
            <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                <h1>Industrial Scale - BioCanvas ISP Series</h1>
            </div>
        </div>

        {/* MAIN SECTION */}
        <section
            id="portfolio-details"
            className="portfolio-details"
            style={{ backgroundColor: 'white', marginBottom: '12rem' }}
        >
            <div className="container">
                <div className="row gy-4">

                    {/* IMAGE SLIDER */}
                    <div className="col-lg-8">
                        <div className="portfolio-details-slider swiper">
                            <Slider {...settings}>
                                {images.map((src, index) => (
                                    <div className="swiper-slide" key={index}>
                                        <div className="img" style={{ textAlign: 'center' }}>
                                            <img
                                                src={src}
                                                alt="Labscale Model"
                                                className="responsive"
                                                style={{ maxHeight: '400px', objectFit: 'contain' }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>

                    {/* DESCRIPTION */}
                    <div className="col-lg-4">
                        <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                            <h3 className='pageheading'>Industrial Scale - BioCanvas ISP Series</h3>

                            <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                Scale up with confidence using our industrial-grade fermenter system, offering vessel volumes from 1,000L to over 100,000L with customizable aspect ratios and precision-machined SUS316L/304 construction finished by electrolytic polishing for superior hygiene. Equipped with AC gear or servo motor drives, Rushton, marine, and foam breaker impellers, and mechanical or magnetic seals, it delivers flexible agitation from 30–1,000 rpm under PID control. Advanced process management includes pH (2.0–14.0), DO (0–200% or 0–20 ppm), temperature (ambient +3℃–80℃), and pressure regulation, all monitored via a 20-inch touchscreen PLC system with auto-sterilization, recipe-based culture sequencing, and full SCADA integration. With ring sparger aeration, 0.2 μm inlet/outlet filtration, comprehensive port configuration, and compliance with ASME-BPE and 21 CFR Part 11 standards, this system ensures hygienic, safe, and fully automated fermentation from sterilization to culture, transfer, and storage—making it the ultimate solution for GMP-level production environments.


                                <br /><br />

                                <a
                                    href="mailto:inst@rmc.in?subject=Inquiry about Labscale Fermenter Model"
                                    style={{
                                        color: '#0d6efd',
                                        fontWeight: '600',
                                        textDecoration: 'underline'
                                    }}
                                >
                                    More Info
                                </a>
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <br />
        <br /><br /><br /><br /><br /><br /><br /><br />
    </Layout>
  )
}

export default IndustrialScale